webpackJsonp([4],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/index.json":
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"allMarkdownRemark": {
				"edges": [
					{
						"node": {
							"excerpt": "",
							"id": "/Users/dschau/Code/Personal/gatsby-images-issue-example/src/pages/07-14-2017-sample-issue/index.md absPath of file >>> MarkdownRemark",
							"frontmatter": {
								"title": "Sample Issue",
								"date": "July 14, 2017",
								"path": "/sample-issue.html"
							}
						}
					}
				]
			}
		},
		"pathContext": {}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---index-66ae7c58368b21399fea.js